import React, { useCallback, useContext } from 'react';

import { Select } from '@gogame/components';
import { FormContext } from '@gogame/form';

import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/constants';

import { DESIGNER, OUTSOURCE_STUDIO, LIST } from './constants';
import { DesignerAndOutsourceStudioContext } from './context';

export const StudioType = () => {
  const { setFieldValue } = useContext(FormContext);
  const { setDesignerType, setDesigner, designerType, path } = useContext(
    DesignerAndOutsourceStudioContext
  );

  const handleChangeDesignerType = useCallback(
    (_, v) => {
      switch (v) {
        case DESIGNER:
          setFieldValue(
            `${path ? path + '.' : ''}${CREATIVE.OUTSOURCE_STUDIO_ID}`,
            undefined
          );
          break;
        case OUTSOURCE_STUDIO:
          setFieldValue(
            `${path ? path + '.' : ''}${CREATIVE.DESIGNER}`,
            undefined
          );
          break;
      }
      setDesignerType(v);
      setDesigner(undefined);
    },
    [setDesignerType, setFieldValue]
  );

  return (
    <Select
      label={'Studio'}
      value={designerType}
      options={LIST}
      onChange={handleChangeDesignerType}
      padding={0}
    />
  );
};
